import React from "react";

const PanelBody = ({ children }) => {
  return <div class="panel-body">{children}</div>;
};

export default PanelBody;



// WEBPACK FOOTER //
// ./src/_components/UI/Panel/PanelBody/index.js